import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';

// login option 3 routing
const AuthLogin3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Login3')));
const AuthRegister3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Register3')));

const Password3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Password3')));
const ResetPassword3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/ResetPassword3')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
    path: '/',
    element: <MinimalLayout />,
    children: [
        {
            path: '/pages/login/login3',
            element: <AuthLogin3 />
        },
        {
            path: '/pages/register/register3',
            element: <AuthRegister3 />
        },
        {
            path: '/pages/password/password3',
            element: <Password3 />
        },
        {
            path: '/pages/password/resetpassword3',
            element: <ResetPassword3 />
        }
    ]
};

export default AuthenticationRoutes;
